export default {
  创作即收益: "Tạo. Kiếm tiền. Nhận thanh toán.",
  加入EBC创作者激励计划: "Tham gia Chương trình Khuyến khích Nhà sáng tạo của chúng tôi và biến tầm ảnh hưởng của bạn thành thu nhập.",
  成为创作者: "Tham gia ngay",
  无限奖励: "Chương trình Khuyến khích Nhà sáng tạo",
  EBC创作者激励计划:
    "Mở rộng nội dung của bạn ra toàn cầu để nhận phần thưởng hàng tháng với Chương trình Khuyến khích Nhà sáng tạo của EBC. ",
  推荐奖励: "Phần thưởng Giới thiệu",
  推荐新用户注册并交易: "Mời người dùng mới giao dịch & nhận khoản thanh toán hàng tháng.",
  内容变现: "Kiếm tiền từ nội dung",
  在EBC: "Biến nội dung chất lượng cao thành thu nhập ổn định.",
  内容进阶: "Tiếp cận toàn cầu",
  从本地创作到全球影响: "Trở thành người có sức ảnh hưởng của chúng tôi để thúc đẩy tương tác với khán giả toàn cầu.",
  预计奖金: "Phần thưởng hàng tháng ước tính",
  均值估算仅供参考: "*Chỉ là ước tính trung bình để tham khảo",
  "800万交易者的信任首选": "Nền tảng giao dịch toàn cầu được 5 triệu nhà giao dịch tin dùng",
  EBC用全球最佳券商的实力:
    "Là Nhà môi giới tốt nhất thế giới, chúng tôi sẽ biến sức ảnh hưởng của bạn thành thu nhập và mang đến cho bạn cơ hội tiếp cận các phần thưởng hấp dẫn và cơ hội toàn cầu.",
  全方位媒体曝光: "Tiếp cận truyền thông toàn diện",
  我们以全球媒体资源:
    "Tham gia các sự kiện của FC Barcelona và kênh truyền thông toàn cầu để phát triển thương hiệu cá nhân và tăng độ nhận diện.",
  全球最强交易环境: "Môi trường giao dịch vượt trội",
  打造极致交易体验:
    "Giao dịch với tốc độ khớp lệnh tính bằng mili-giây, thanh khoản cấp tổ chức và tính năng sao chép giao dịch xuất sắc.",
  专属客户经理: "Quản lý tài khoản chuyên biệt",
  我们为每位创作者配专属运营:
    "Nhận hướng dẫn 1-1 để tạo nội dung chất lượng, được hỗ trợ và tối đa hóa thu nhập.",
  如何成为创作者: "Cách trở thành Nhà sáng tạo của chúng tôi",
  从内容创作到奖励提现: "Nhận hỗ trợ 1-1 ở mọi bước.",
  立即加入:"Tham gia ngay",
  注册提交资料:"Đăng ký & Gửi thông tin của bạn",
  发布专业内容:"Tạo & Chia sẻ nội dung chất lượng về EBC",
  获取月度奖励:"Nhận thanh toán hàng tháng",
  活动须知:"Quy định chương trình",
  notices:[
    "1. Nhà sáng tạo phải sở hữu chuyên mục nội dung riêng, tài khoản mạng xã hội hoặc kênh cộng đồng, và có khả năng sản xuất nội dung liên tục trong ít nhất ba tháng. Hình thức nội dung có thể bao gồm và không giới hạn ở  những mục sau: phân tích chiến lược, đồ họa minh họa, và khóa học video.",
    "2. Nội dung phải đảm bảo tính nguyên bản, chuyên nghiệp và tuân thủ quy định. Trong trường hợp đạo văn, viết lại trái phép hoặc đăng nội dung bị cấm, nền tảng có quyền hủy bỏ quyền tham gia và các quyền lợi liên quan.",
    "3. Thanh toán hàng tháng sẽ dựa trên mức độ hoàn thành của nhà sáng tạo, với phần thưởng được chuyển trong tuần đầu tiên của tháng kế tiếp cho những người đủ điều kiện.",
    "4. Chương trình này không thể tham gia cùng lúc với các chương trình khác (như Chương trình Phát triển Quản lý Quỹ hoặc Chương trình Hỗ trợ Phát triển Đối tác). Nhà sáng tạo chỉ được chọn một chương trình tại một thời điểm.",
    `5. Nền tảng sẽ cung cấp hỗ trợ vận hành chuyên biệt cho các nhà
              sáng tạo xuất sắc, bao gồm hỗ trợ nội dung và tài nguyên chuyển
              đổi. Mọi thắc mắc, vui lòng liên hệ dịch vụ khách hàng hoặc email
              <a href="mailto:mkt@ebc.com">mkt@ebc.com</a>.`,
    "6. Để đảm bảo công bằng, EBC giữ quyền giải thích cuối cùng cho chương trình này và có thể loại bỏ bất kỳ hành vi vi phạm hoặc lạm dụng nào."
  ],
  section4Tips:"* 3 năm liên tiếp được World Finance vinh danh: Nền tảng giao dịch FX tốt nhất 2023, Nhà môi giới CFD tốt nhất 2024, Nền tảng giao dịch tốt nhất 2025, Nhà môi giới đáng tin cậy nhất 2025. Giải thưởng Online Money Awards: Nhà cung cấp CFD tốt nhất 2025. "
};
